module.exports = __webpack_public_path__ + "static/media/dmartinson_email.c445595f.svg";